import $ from 'jquery';

export default function() {
    var $gallery = $('.swiper--gallery');

    // only load our form helpers if we have a form on the current page
    if ($gallery.length) {
        require.ensure([], () => {
            require([
                'photoswipe/dist/photoswipe.js',
                'photoswipe/dist/photoswipe-ui-default.js'
            ], function(PhotoSwipe, PhotoSwipeUIDefault) {

                $gallery.each(function() {
                    var $galleryItems = $(this).find('li'),
                        pswpElement = document.querySelectorAll('.pswp')[0],
                        encounteredItems = {},
                        pswpItems = [],
                        pswpIndex = 0,
                        pswp;

                    // loop over the gallery to build up the photoswipe items
                    $galleryItems.each(function() {
                        var $item = $(this),
                            src = $item.data('img'),
                            size = $item.data('size').split('x'),
                            pswdItem;

                        // if we have this image the first time
                        if (!encounteredItems[src]) {
                            // build the photoswipe item
                            pswdItem = {
                                src: src,
                                w: parseInt(size[0], 10),
                                h: parseInt(size[1], 10),
                                el: $item // save link to element for getThumbBoundsFn
                            };

                            // store that we already had this item
                            encounteredItems[src] = {
                                item: pswdItem,
                                index: pswpIndex
                            };

                            // push the item to the photoswipe list
                            pswpItems.push(pswdItem);
                            pswpIndex++;
                        }

                        // init image click event
                        $item.off('click').on('click', function(event) {
                            event.preventDefault();

                            var $el = $(this),
                                options = {
                                    index: encounteredItems[$el.data('img')].index
                                };

                            // open the photoswipe gallery
                            pswp = new PhotoSwipe(pswpElement, PhotoSwipeUIDefault, pswpItems, options);

                            // // reinit photoswipe gallery cause of a visibility bug on close
                            // pswp.listen('close', function() {
                            //     pswp.init();
                            // }.bind(pswp));
                            pswp.init();
                        });
                    });
                });
            });
        }, 'gallery');
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/lib/gallery.js